module.exports = __webpack_public_path__ + "img/MilkShopTea.23175707.svg";